import React, { useState } from "react";
import { Link } from "react-router-dom";
import coinIcon from "../assets/coin_icon.png";
import {
  Navbar,
  Nav,
  Container,
  Button,
  Offcanvas,
  Dropdown,
  DropdownButton,
  ButtonGroup,
} from "react-bootstrap";

function AppNavbar() {
  const [showSidebar, setShowSidebar] = useState(false);
  const handleClose = () => setShowSidebar(false);
  const handleShow = () => setShowSidebar(true);
  const [aboutOpen, setAboutOpen] = useState(false);

  return (
    <>
      <Navbar
        bg="light"
        expand="lg"
        className="navbar-wrapper"
        rel="noopener noreferrer sponsored"
      >
        <Container>
          {/* Brand */}
          <Navbar.Brand as={Link} to="/" className="m-3">
            <img
              src={coinIcon}
              width="40"
              height="40"
              className="me-2"
              alt="Coin Icon"
              rel="noopener noreferrer sponsored"
            />
            <span className="navbar-logo-text-span">
              Free Credit {new Date().getFullYear()}
            </span>
          </Navbar.Brand>

          {/* Mobile toggle button */}
          <Button className="d-lg-none nav-hamburger-btn" onClick={handleShow}>
            Menu ☰
          </Button>

          {/* Desktop nav links */}
          <Nav className="ms-auto d-none d-lg-flex">
            <Button as={Link} to="/">
              Home
            </Button>
            <div className="vr"></div>
            <Button variant="secondary">Free Credit List</Button>
            <div className="vr"></div>
            <DropdownButton
              id="dropdown-basic-button"
              title="About Us"
              variant="secondary"
            >
              <Dropdown.Item as={Link} to="/aboutus">
                About Us
              </Dropdown.Item>
              <Dropdown.Item href="#/action-2">
                Casino Review Criteria
              </Dropdown.Item>
              <Dropdown.Item href="#/action-3">Editorial Policy</Dropdown.Item>
              <Dropdown.Item href="#/action-3">Privacy Policy</Dropdown.Item>
              <Dropdown.Item href="#/action-3">
                Responsible-Gaming
              </Dropdown.Item>
              <Dropdown.Item href="#/action-3">Contact Us</Dropdown.Item>
            </DropdownButton>
          </Nav>
        </Container>
      </Navbar>

      {/* Sidebar for mobile */}
      <Offcanvas
        show={showSidebar}
        onHide={handleClose}
        placement="start"
        className="nav-offcanvas-container"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Menu</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <ButtonGroup vertical className="w-100">
            <Button
              variant="secondary"
              className="d-flex"
              as={Link}
              to="/"
              onClick={handleClose}
            >
              Home
            </Button>
            <Button
              variant="secondary"
              className="d-flex"
              onClick={handleClose}
            >
              Free Credit List
            </Button>

            {/* Expand/Collapse Parent */}
            <Button
              variant="secondary"
              onClick={() => setAboutOpen(!aboutOpen)}
              className="d-flex align-items-center justify-content-between"
            >
              About Us
              <span style={{ fontSize: "0.8em" }}>{aboutOpen ? "▲" : "▼"}</span>
            </Button>

            {/* Collapsible Items */}
            {aboutOpen && (
              <div className="sidebar-collapse-items">
                <Button
                  variant="secondary"
                  as={Link}
                  to="/aboutus"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  About Us
                </Button>
                <Button
                  variant="secondary"
                  href="#"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  Casino Review Criteria
                </Button>
                <Button
                  variant="secondary"
                  href="#"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  Editorial Policy
                </Button>
                <Button
                  variant="secondary"
                  href="#"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  Privacy Policy
                </Button>
                <Button
                  variant="secondary"
                  href="#"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  Responsible-Gaming
                </Button>
                <Button
                  variant="secondary"
                  href="#"
                  onClick={handleClose}
                  className="mt-2 w-100"
                >
                  Contact Us
                </Button>
              </div>
            )}
          </ButtonGroup>
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
}

export default AppNavbar;
